import React from 'react';
import './Handle.css';

export default function Handle() {
  return (
    <div className='handle'>
      <div className='buttons'>
        <div className='close' />
        <div className='minimize' />
        <div className='maximize' />
      </div>
      <span className='title'>harris@mbp: ~ (zsh)</span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Handle.js